import { MutableRefObject } from 'react';
import { AdvancedFilter, CategoryFilterValues } from '../../../../../interfaces/interfaces';

interface FilterCategoryInterface {
  category: AdvancedFilter;
  filterValues: MutableRefObject<Record<string, boolean>>;
  setFilterValue: (cfv: CategoryFilterValues, checked: boolean) => void;
}

const FilterCategory = ({ category, filterValues, setFilterValue }: FilterCategoryInterface) => {
  return (
    <li className={`rounded py-1 px-2 ${!category.isMainFilter ? 'border-l-2' : ''}`} key={category._id}>
      <p className="font-bold text-base">{category.name}</p>
      <hr />
      {category.categoryFilterValues.map((filterValue) => (
        <label key={filterValue._id} className="flex cursor-pointer justify-between items-center p-1">
          <span className="mr-2.5">{filterValue.value}</span>
          <input
            defaultChecked={filterValues.current[filterValue._id]}
            onChange={({ target }) => setFilterValue(filterValue, target.checked)}
            type="checkbox"
          />
        </label>
      ))}
    </li>
  );
};
export default FilterCategory;
